import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
@Component({
  selector: 'app-filter-search-with-any',
  templateUrl: './filterSearchWithAny.component.html',
  styleUrls: ['./filterSearchWithAny.component.scss']
})
export class FilterSearchWithAnyComponent implements OnInit {

 @Input() data: { placeholder: string[], optionList: any[], optionValue: any[],  };
  @Input() isAllocateSubject: boolean;
  @Output() messageEvent = new EventEmitter<any>();
  visible = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  inputDataCtrl = new FormControl();
  // filteredinputDatas: Observable<string[]>;
  inputDatas: any[] = [];
  options: string[] = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];

  @ViewChild('inputDataInput', {static: true}) inputDataInput: ElementRef;
  userControl = new FormControl();

  users = [ ];

  selectedUsers: string[] = new Array<string>();

  filteredUsers: Observable<string[]>;
  lastFilter: string = '';
  placeholder: any;

  constructor() { }
  ngOnInit() {
    this.filteredUsers = this.inputDataCtrl.valueChanges.pipe(
      startWith(null),
      map((inputData: string | null) => inputData ? this._filter(inputData) : this.users.slice()));

  }
  ngOnChanges(){

    this.users = [];
    for(let item of this.data.optionList || []){
      this.users.push(item)
    }

    this.placeholder = this.data.placeholder;
    this.inputDatas = this.data.optionValue;

    for(let item of this.inputDatas){
      if(this.users.includes(item))
         this.users.splice(this.users.indexOf(item), 1)
    }
    this.updateFilterOptions();
  }
  updateFilterOptions(){
    this.filteredUsers = this.inputDataCtrl.valueChanges.pipe(
      startWith(null),
      map((inputData: string | null) => inputData ? this._filter(inputData) : this.users.slice()));
  }
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our inputData
    if ((value || '').trim()) {
      if(this.users.includes(value)){
        this.inputDatas.push(value.trim());
        this.users.splice(this.users.indexOf(value), 1);
        this.updateFilterOptions();
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.inputDataCtrl.setValue(null);
  }

  remove(inputData: string): void {
    const index = this.inputDatas.indexOf(inputData);

    if (index >= 0) {
      this.inputDatas.splice(index, 1);
      this.users.push(inputData);
      this.updateFilterOptions();
    }
    this.messageEvent.emit(this.inputDatas);

  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.inputDataInput.nativeElement.blur();
    this.inputDatas.push(event.option.viewValue);
    this.inputDataInput.nativeElement.value = '';
    this.inputDataCtrl.setValue(null);
    this.users.splice(this.users.indexOf(event.option.value), 1);
    this.updateFilterOptions();
    this.messageEvent.emit(this.inputDatas);
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    
    // Return items that contain the input string anywhere in the word
    return this.users.filter(inputData => inputData.toLowerCase().includes(filterValue));
  }

}
